var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.5C8.70643 2.5 8.33333 2.8731 8.33333 3.33333C8.33333 3.79357 8.70643 4.16667 9.16667 4.16667H15C15.4602 4.16667 15.8333 4.53976 15.8333 5V15C15.8333 15.4602 15.4602 15.8333 15 15.8333H9.16667C8.70643 15.8333 8.33333 16.2064 8.33333 16.6667C8.33333 17.1269 8.70643 17.5 9.16667 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V5C17.5 3.61929 16.3807 2.5 15 2.5H9.16667Z",
    fill: "#5F3FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6402 6.96651C10.3455 6.61295 9.82008 6.56518 9.46651 6.85982C9.11295 7.15445 9.06518 7.67992 9.35982 8.03349L10.3041 9.16667H3.33333C2.8731 9.16667 2.5 9.53976 2.5 10C2.5 10.4602 2.8731 10.8333 3.33333 10.8333H10.3041L9.35982 11.9665C9.06518 12.3201 9.11295 12.8455 9.46651 13.1402C9.82008 13.4348 10.3455 13.3871 10.6402 13.0335L13.1681 10L10.6402 6.96651Z",
    fill: "#5F3FC0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.528b4e16bfc5b8a407b95636108ad831.svg";
export { ForwardRef as ReactComponent };